module.exports = __webpack_public_path__ + "img/Flag_of_the_Czech_Republic.9c5898c6.svg";